export default {
      id: "power-bi-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#power-bi",
      toString: function () {
        return this.url;
      }
    }